import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useInboxTeams, useTeamMove, userCoversTeam } from '@hooks';
import { CHANNEL } from '@constants/channels';
import MoveToTeamModal from './Inbox/MoveToTeamModal';

// One definition of the move-to-team affordance for every surface (header menu,
// details drawer): same target rule, same modal wiring, same aftermath.
export const useMoveToTeam = ({ activeConversation, setActiveConversation, filterRef }) => {
    const [moveModalOpen, setMoveModalOpen] = useState(false);

    const currentUser = useSelector(state => state.auth.user);
    const { messagingTeams } = useInboxTeams();
    const onTeamMoved = useTeamMove({ setActiveConversation, filterRef });

    const isArchived = activeConversation?.channelId === CHANNEL.ARCHIVED;
    // Moving mutates the current team — collaborators without team access can't (the server rejects them anyway)
    const canMoveToTeam =
        !isArchived &&
        userCoversTeam(currentUser, activeConversation?.teamId) &&
        messagingTeams.some(team => team.id !== activeConversation?.teamId);

    const moveToTeamModal = moveModalOpen ? (
        <MoveToTeamModal
            open={moveModalOpen}
            onClose={() => setMoveModalOpen(false)}
            activeConversation={activeConversation}
            messagingTeams={messagingTeams}
            onMoved={(conversation, team) => onTeamMoved(conversation, { team, isActor: true })}
        />
    ) : null;

    return { canMoveToTeam, openMoveToTeam: () => setMoveModalOpen(true), moveToTeamModal };
};
